import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Logo } from "../components/Logo";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(window.location.search);
    const tokenFromQuery = params.get("token");
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    const finish = (user) => {
      window.history.replaceState(null, "", window.location.pathname);
      const u = user || {};
      const dest = (u.role === "admin" || u.has_paid) ? "/dashboard" : "/";
      window.location.replace(dest);
    };

    const run = async () => {
      try {
        // Login nativo con Google: el backend ya creó la sesión y nos pasa el token.
        if (tokenFromQuery) {
          localStorage.setItem("session_token", tokenFromQuery);
          const me = await api.get("/auth/me");
          setUser(me.data);
          finish(me.data);
          return;
        }
        const res = await api.post("/auth/session", { session_id: sessionId });
        if (res.data.session_token) {
          localStorage.setItem("session_token", res.data.session_token);
        }
        setUser(res.data.user);
        finish(res.data.user);
      } catch (e) {
        navigate("/login?auth=error", { replace: true });
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background gap-6">
      <Logo size={56} />
      <div className="w-10 h-10 rounded-full border-4 border-brand-sage/30 border-t-brand-terracotta animate-spin" />
      <p className="text-brand-ink/60 font-nunito">Iniciando sesión…</p>
    </div>
  );
}
